module.exports = __webpack_public_path__ + "h5/img/logo_2.888e9b8b.png";